import React from 'react';

import { HiCurrencyDollar } from 'react-icons/hi';

const Prices: React.FC = () => (
  <>
    <h5 className="spacer">TABELA DE PREÇOS</h5>

    <div className="form-group head-text">
      <p>
        Envie-nos um e-mail para
        {' '}
        <a href="mailto:comercial@jornaldocomercio.com.br?subject=Publicidade%20Legal%20-%20Orçamento">comercial@jornaldocomercio.com.br</a>
        .
      </p>
    </div>
  </>
);

export default Prices;
